import React from 'react';

import {Button} from 'shells/button/button';

import styles from './table-no-results-view.module.css';

type Props = {
    removeFilters: () => void;
};

export function TableNoResultsView(props: Props) {
    return (
        <div className={styles['no-results']}>
            <img
                src='/include/images/entity-lists/empty-search.png'
                className='ui-entity-list__no-results'
            />
            <Button variant='primary' size='big' onClick={props.removeFilters}>
                Remove filters
            </Button>
        </div>
    );
}
